import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAngularSvgIcon } from 'angular-svg-icon';

import { appRoutes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AuthService } from './shared/services/auth-service/auth.service';
import { accessTokenInterceptorProvider } from './shared/interceptor/access-token.interceptor';
import { accessDeniedInterceptorProvider } from './shared/interceptor/access-denied.interceptor';
registerLocaleData(en);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAngularSvgIcon(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    accessTokenInterceptorProvider,
    accessDeniedInterceptorProvider,
    provideAnimationsAsync(),
    provideNzI18n(en_US),
    importProvidersFrom(FormsModule),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    NzModalService,
    AuthService
  ]
};
